import React from "react";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import Content from "components/sidebar/components/Content";
import { IoMenuOutline } from "react-icons/io5";
import { Mark } from "components/icons/Mark";
import {
  SIDEBAR_WIDTH_XL_COLLAPSED,
  SIDEBAR_WIDTH_XL_EXPANDED,
  useSidebar,
} from "contexts/SidebarContext";

function Sidebar(props: { routes: RoutesType[]; [x: string]: any }) {
  const { routes } = props;
  const { sidebarCollapsed } = useSidebar();

  const variantChange = "width 0.2s ease, min-width 0.2s ease";
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  const sidebarBg = useColorModeValue("white", "navy.800");
  const sidebarMargins = "0px";

  const sidebarW = sidebarCollapsed
    ? SIDEBAR_WIDTH_XL_COLLAPSED
    : SIDEBAR_WIDTH_XL_EXPANDED;

  return (
    <Box display={{ sm: "none", xl: "block" }} position="fixed" minH="100%">
      <Box
        bg={sidebarBg}
        transition={variantChange}
        w={`${sidebarW}px`}
        minW={`${sidebarW}px`}
        maxW={`${sidebarW}px`}
        h="100vh"
        m={sidebarMargins}
        minH="100%"
        overflowX="hidden"
        overflowY="auto"
        boxShadow={shadow}
      >
        <Content routes={routes} />
      </Box>
    </Box>
  );
}

export function SidebarResponsive(props: { routes: RoutesType[] }) {
  const sidebarBackgroundColor = useColorModeValue("white", "navy.800");
  const menuColor = useColorModeValue("gray.400", "white");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef<HTMLDivElement>(null);

  const { routes } = props;

  return (
    <Flex display={{ sm: "flex", xl: "none" }} alignItems="center">
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
        <Mark
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: "pointer" }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={
          document.documentElement.dir === "rtl" ? "right" : "left"
        }
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent w="285px" maxW="285px" bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex="3"
            onClick={onClose}
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0" overflowY="auto">
            <Content routes={routes} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default Sidebar;
